import { render, staticRenderFns } from "./video_3.vue?vue&type=template&id=61baf07e&scoped=true&"
var script = {}
import style0 from "./video_3.vue?vue&type=style&index=0&id=61baf07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61baf07e",
  null
  
)

export default component.exports